import anime from 'animejs';

export const menuInit = (element) => {
  const voices = [...element.querySelectorAll('.navigator__link')];
  const lines = [...element.querySelectorAll('.app__line')];
  anime.set(element, { translateY: '-100%' });
  anime.set(voices, { translateY: 20, opacity: 0 });
  anime.set(lines, { scaleX: 0, transformOrigin: '0% 0%' });
};

export const menuOpen = (element) => {
  const voices = [...element.querySelectorAll('.navigator__link')];
  const lines = [...element.querySelectorAll('.app__line')];

  const timeline = anime.timeline();
  timeline.add({
    targets: element,
    translateY: 0,
    easing: 'easeInOutCubic',
    duration: 600,
  });
  timeline.add({
    targets: voices,
    translateY: 0,
    opacity: 1,
  }, 500);
  timeline.add({
    targets: lines,
    scaleX: 1,
  }, 500);
  return timeline;
};

export const menuClose = (element) => {
  const voices = [...element.querySelectorAll('.navigator__link')];
  const lines = [...element.querySelectorAll('.app__line')];

  const timeline = anime.timeline();
  timeline.add({
    targets: voices,
    translateY: 20,
    opacity: 0,
  }, 1);
  timeline.add({
    targets: lines,
    scaleX: 0,
    transformOrigin: '0% 0%',
  }, 1);
  timeline.add({
    targets: element,
    translateY: '-100%',
    easing: 'easeInOutCubic',
    duration: 600,
  }, 600);
  return timeline;
};
